<template>
  <div class="channel-list-wrapper">
    <div v-for="channel in channels" :key="channel.id" style="margin: 0 10px 5px 0;">
      <el-card shadow="hover">
        <el-tooltip :content="channel.channel_type_title">
          <social-icon 
            class="social-icon"
            :type="channel.channel_type_title" 
          />
        </el-tooltip>
        <strong class="channel-handle">{{ channel.handle }}</strong>
        <el-tooltip :content="`${active ? 'Deactivate' : 'Activate'} ${channel.handle}`">
          <span 
            class="fa fa-fw pull-right channel-action"
            :class="logoClass" 
            :style="{color: logoColor}"
            @click="toggleChannelActive(channel)"
          >
          </span>
        </el-tooltip>
      </el-card>
    </div>
  </div>
</template>

<script>
import SocialIcon from '@/components/common/Icons/SocialIcon';

export default {
  name: 'ChannelList',
  components: { SocialIcon },
  props: {
    channels: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    logoClass() {
      return this.active ? 'fa-times' : 'fa-check';
    },
    logoColor() {
      return this.active ? 'red' : 'green';
    },
  },
  methods: {
    toggleChannelActive(channel) {
      this.$emit(this.active ? 'deactivateChannel' : 'activateChannel', channel);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.channel-handle {
  color: $text-color;
}

.channel-list-wrapper {
  max-height: 600px;
  overflow: hidden;
  overflow-y: scroll;
}

.channel-action {
  cursor: pointer;
  outline: none;
}
</style>





// WEBPACK FOOTER //
// ChannelList.vue?06bad1dc